import { render, staticRenderFns } from "./CoursePlan.vue?vue&type=template&id=af6edcf4&scoped=true&"
import script from "./CoursePlan.vue?vue&type=script&lang=js&"
export * from "./CoursePlan.vue?vue&type=script&lang=js&"
import style0 from "./CoursePlan.vue?vue&type=style&index=0&id=af6edcf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6edcf4",
  null
  
)

export default component.exports